// Paste this code in your Shopify theme's theme.liquid file, just before </head>
// Or add it to a custom script section

 
(function() {
  // Configuration: Add your third-party scripts here
  const scriptsToLoad = [
    {
      type: 'script',
      src: 'https://api.webbotify.com/chat/5552121602112499810718109.js',
      async: true,
      defer: false
    },
    // {
    //   type: 'script',
    //   src: 'https://example.com/script2.js',
    //   async: true,
    //   defer: false
    // },
    // For inline scripts, use:
    // {
    //   type: 'inline',
    //   code: 'console.log("Inline script loaded");'
    // }
    // For external CSS:
    // {
    //   type: 'style',
    //   href: 'https://example.com/style.css'
    // }
  ];

  let scriptsLoaded = false;
  const scrollThreshold = 0.5; // 50% of page

  function calculateScrollPercentage() {
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    // Calculate scroll percentage
    const scrollableHeight = documentHeight - windowHeight;
    const scrollPercentage = scrollableHeight > 0 ? scrollTop / scrollableHeight : 0;
    
    return scrollPercentage;
  }

  function loadScripts() {
    if (scriptsLoaded) return;
    
    scriptsLoaded = true;
    console.log('Loading third-party scripts at 50% scroll...');

    scriptsToLoad.forEach((config, index) => {
      if (config.type === 'script') {
        const script = document.createElement('script');
        script.src = config.src;
        
        if (config.async) script.async = true;
        if (config.defer) script.defer = true;
        if (config.id) script.id = config.id;
        
        script.onload = function() {
          console.log(`Script ${index + 1} loaded:`, config.src);
        };
        
        script.onerror = function() {
          console.error(`Failed to load script:`, config.src);
        };
        
        document.head.appendChild(script);
        
      } else if (config.type === 'inline') {
        const script = document.createElement('script');
        script.textContent = config.code;
        if (config.id) script.id = config.id;
        document.head.appendChild(script);
        
      } else if (config.type === 'style') {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = config.href;
        if (config.id) link.id = config.id;
        
        link.onload = function() {
          console.log(`Stylesheet loaded:`, config.href);
        };
        
        document.head.appendChild(link);
      }
    });

    // Remove event listener after scripts are loaded
    window.removeEventListener('scroll', handleScroll);
    window.removeEventListener('resize', handleScroll);
  }

  function handleScroll() {
    const scrollPercentage = calculateScrollPercentage();
    
    if (scrollPercentage >= scrollThreshold) {
      loadScripts();
    }
  }

  // Check on page load (in case user reloads at bottom of page)
  function init() {
    if (calculateScrollPercentage() >= scrollThreshold) {
      loadScripts();
    } else {
      // Add scroll and resize listeners
      window.addEventListener('scroll', handleScroll, { passive: true });
      window.addEventListener('resize', handleScroll, { passive: true });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
 